export const constructGoogleFormUrl = (values: any) => {
  return `https://docs.google.com/forms/d/e/1FAIpQLSdvADH1y9CNKSedDlDXR_WjQQVTGt13hOQsRE8pDnshhXDj4g/viewform?usp=pp_url&entry.1884265043=${encodeURIComponent(
    values.name
  )}&entry.1109986321=${encodeURIComponent(
    values.firstname
  )}&entry.1212348438=${encodeURIComponent(
    values.for
  )}&entry.1486402282=${encodeURIComponent(
    values.birthdate
  )}&entry.253779224=${encodeURIComponent(
    values.country
  )}&entry.513669972=${encodeURIComponent(
    values.phone
  )}&entry.1091920016=${encodeURIComponent(
    values.email
  )}&entry.936175411=${encodeURIComponent(
    values.program
  )}&entry.634782068=${encodeURIComponent(
    values.level
  )}&entry.2011259177=${encodeURIComponent(
    values.frequency
  )}&entry.790000968=${encodeURIComponent(
    values.days
  )}&entry.1975473340=${encodeURIComponent(
    values.alone
  )}&entry.2071853404=${encodeURIComponent(
    values.additionalPhone
  )}&entry.1678615449=${encodeURIComponent(
    values.alreadyLearnArabic
  )}&entry.1660025140=${encodeURIComponent(
    values.learningInfo
  )}&entry.1602489906=${encodeURIComponent(
    values.confirmation ? "oui" : "Non"
  )}`;
};
